angular.module('impactx.dashboard').controller('DashboardCompanyMessageCtrl', ['$scope', 'dataGen', DashboardCompanyMessageCtrl]);

function DashboardCompanyMessageCtrl($scope, dataGen) {
    dataGen.getData($scope, {}, "/dashboard/companymessage").then(function () {
        $scope.isHidden.value = !$scope.data.hasMessage;
    });
}